import {useQuery} from "@tanstack/react-query";
import {getBanners} from "../../api/utils";
import {BANNER_GROUP_MAIN} from "../../Config";

export default function Banners() {
    const {data: banners} = useQuery({
        queryKey: ['banners', BANNER_GROUP_MAIN],
        queryFn: () => getBanners(BANNER_GROUP_MAIN)
    });

    const activeBanners = banners?.filter(b => b.is_active);

    if (!activeBanners?.length) return null;

    return (
        <div className="about__img">
            {activeBanners.map((banner, index) => (
                <picture key={index}>
                    {banner.url
                        ? <a href={banner.url}><img className="w-100" src={'https://www.pride.ru' + banner.image_with_path} alt=""/></a>
                        : <img className="w-100" src={'https://www.pride.ru' + banner.image_with_path} alt=""/>
                    }
                </picture>
            ))}
        </div>
    );
}
